export const manageDevices = {
	solicitationTypes: {
		permanent: "Permanent",
		temporary: "Temporaire",
	},
	deviceListByPlace: {
		title: "Liste des équipements par lieu",
		totalDevices: "Total des équipements",
		table: {
			emptyState: {
				title: "Il n'y a encore rien ici",
			},
			columns: {
				contractStatus: "Statut du contrat",
				contractId: "ID du contrat",
				quantity: "Quantité",
				serialNumber: "Numéro de série",
				equipmentModel: "Modèle",
				requestType: "Type de demande",
			},
		},
		filters: {
			byContractId: "Filtrer par ID de contrat",
			bySerialNumber: "Filtrer par numéro de série",
			byModel: "Filtrer par modèle",
			byStatus: "Filtrer par statut",
		},
		tag: {
			pendingSignature: "Signature en attente",
			signatureExpired: "Signature expirée",
			contractExpired: "Contrat expiré",
			active: "Contrat actif",
			closed: "Contrat clôturé",
		},
		btnExport: "Exporter",
		requestEquipments: "Demander des équipements",
	},
};
